import { BrowserRouter } from "react-router-dom";

import AppRoutes from "components/AppRoutes";
import Loading from "components/common/loading/Loading";

import { getRedirectPath } from "utils/routes.util";

const AppShell = () => {
  const redirectPath = getRedirectPath();

  if (!redirectPath) return <Loading height="100%" width="100%" />;

  return (
    <BrowserRouter>
      <AppRoutes redirectPath={redirectPath} />
    </BrowserRouter>
  );
};

export default AppShell;
